import styled from 'styled-components';

export const MobileSocialContainer = styled.div`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md};
`;

export const HeaderText = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  font-size: ${({ theme }) => theme.fontSizes.medium};
`;

export const HeaderTextBold = styled.span`
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.text};
`;

export const InputContainer = styled.div`
  background: rgba(132, 73, 2, 0.08);
  width: 100%;
  padding: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  height: 74px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div`
  margin-top: ${({ theme }) => theme.spacing.lg};
  margin-right: ${({ theme }) => theme.spacing.xs};
  margin-left: ${({ theme }) => theme.spacing.xs};
  color: ${({ theme }) => theme.colors.primary};
`;

export const StyledFormControl = styled.div`
  width: calc(100% - 50px);
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const StyledFormWrapper = styled.div`
  .MuiInputLabel-root {
    font-weight: 700 !important;
    color: ${({ theme }) => theme.colors.primary} !important;
    text-transform: uppercase;
  }
  
  .MuiInputBase-root {
    font-weight: 700 !important;
  }
`;

export const MobilePrefix = styled.span`
  color: ${({ theme }) => theme.colors.text};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  
  .MuiButton-root {
    width: 100%;
    box-shadow: none;
    border: 1px solid #E2E2E2;
    
    &:hover {
      box-shadow: none;
    }
  }
  
  .valid-btn {
    background-color: ${({ theme }) => theme.colors.primary};
    color: white;
  }
  
  .invalid-btn {
    background-color: ${({ theme }) => theme.colors.gray};
    color: ${({ theme }) => theme.colors.darkGray};
  }
`;


export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
